<template>
  <h1>{{ computedTitle }}</h1>
  <p v-if="computedDescription.length" v-html="computedDescription"></p>
  <Teleport to="#header-image">
    <transition name="fade">
      <img
        :key="selected_category"
        class="archive-header-img"
        :src="computedSrc"
        alt=""
        v-if="isDesktop"
      />
    </transition>
  </Teleport>
</template>

<script>
import { mapState } from "vuex";
import { useMediaQuery } from "@vueuse/core";

export default {
  name: "ProductPageHeader",
  props: {
    title: {
      type: String,
      default: "",
    },
    src: {
      type: String,
      default: "",
    },
  },
  setup() {
    const isDesktop = useMediaQuery("(min-width: 991.98px)");
    return {
      isDesktop,
    };
  },
  computed: mapState({
    selected_category: (state) => state.product_filters.category,
    computedTitle: function (state) {
      if (state.product_filters.category) {
        return (
          state.categories[state.product_filters.category]?.name ?? this.title
        );
      }

      return this.title;
    },
    computedDescription: function (state) {
      if (state.product_filters.category) {
        return (
          state.categories[state.product_filters.category]?.description ?? ""
        );
      }
      return "";
    },
    computedSrc: function (state) {
      if (state.product_filters.category) {
        return (
          state.categories[state.product_filters.category]?.acf?.oletuskuva
            ?.url ?? this.src
        );
      }

      return this.src;
    },
  }),
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
